import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import PromoCodeService from "../services/PromoCodeService";

export const PromoCodeContext = createContext("PromoCodeContext");

const PromoCodeContextProvider = ({ children }) => {
	const [promoCodeList, setPromoCodeList] = useState([]);
	const [loadingPromoCodeList, setLoadingPromoCodeList] = useState(false);
	const [promoCodeListErrorMsg, setPromoCodeListErrorMsg] = useState("");
	const [totalElements, setTotalElements] = useState(0);

	const getPromoCodeList = async (params) => {
		setLoadingPromoCodeList(true);
		setPromoCodeListErrorMsg("");
		try {
			const response = await PromoCodeService.getPromoCodeList(params);
			setPromoCodeList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setPromoCodeListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingPromoCodeList(false);
		}
	};

	return (
		<PromoCodeContext.Provider
			value={{
				getPromoCodeList,
				promoCodeList,
				totalElements,
				loadingPromoCodeList,
				promoCodeListErrorMsg,
			}}
		>
			{children}
		</PromoCodeContext.Provider>
	);
};

export default PromoCodeContextProvider;
